import axios from 'axios';

const DEFAULT_API_URL =
  typeof window !== 'undefined' && window.location?.origin
    ? window.location.origin
    : 'http://localhost:5001';

const rawApiUrl = process.env.REACT_APP_API_URL || DEFAULT_API_URL;
const normalizedApiUrl = rawApiUrl.replace(/\/+$/, '');

export const API_ROOT_URL = normalizedApiUrl;
export const API_BASE_URL = `${API_ROOT_URL}/api`;

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.dispatchEvent(new CustomEvent('auth:unauthorized'));
    }

    return Promise.reject(error);
  }
);

export default apiClient;
